module.exports = __webpack_public_path__ + "img/b03.f5cc8832.png";